import React from 'react';
import IntroWithButton from '../global/IntroWithButton';
import style from './CarouselSlide.module.scss';

const CarouselSlide = props => {
  return (
    <div className={style.slideWrap}>
      <div
        className={`slide-image ${style.slideImage}`}
        style={{ backgroundImage: `url(${props.image})` }}
      />
      <div className={style.slideText}>
        <IntroWithButton
          title={props.title}
          path={!props.buttonCTA ? null : props.path}
          subtitle={props.subtitle}
          colorTheme={props.color_theme}
          buttonText={props.buttonCTA}
          noButton={!props.buttonCTA}
          textWhite
          noPad
          startHidden
          noMobileRule
          show={
            !props.waitingForLoad &&
            props.index === props.currentIndex &&
            !props.animating &&
            props.revealText
          }
          doSplitText={true}
          index={`carousel${props.index}`}
        />
      </div>
    </div>
  );
};

export default CarouselSlide;



// WEBPACK FOOTER //
// ./src/components/ui/CarouselSlide.js